<template>
  <div class="container">
    <text-input
      v-model.trim="$v.personeelslid.naam.$model"
      id="pLidNaam"
      :label="labels.naam"
      :is-dirty="personeelslid.naam != cache.naam"
      :validation-object="$v.personeelslid.naam"
      :is-disabled="disabledFieldsMap.naam"
      :info="infoForInput('naam')"
    >
    </text-input>
    <text-input
      v-model="$v.personeelslid.voornaam.$model"
      id="pLidVoornaam"
      :label="labels.voornaam"
      :is-dirty="personeelslid.voornaam != cache.voornaam"
      :validation-object="$v.personeelslid.voornaam"
      :is-disabled="disabledFieldsMap.voornaam"
      :info="infoForInput('voornaam')"
    >
    </text-input>
    <text-input
      v-model="$v.personeelslid.voornaam2.$model"
      id="pLidVoornaam2"
      :label="labels.voornaam2"
      :is-dirty="personeelslid.voornaam2 != cache.voornaam2"
      :validation-object="$v.personeelslid.voornaam2"
      :is-disabled="disabledFieldsMap.voornaam2"
      :info="infoForInput('voornaam2')"
    >
    </text-input>
    <text-input
      v-model="$v.personeelslid.roepnaam.$model"
      id="pLidRoepnaam"
      :label="labels.roepnaam"
      :is-dirty="personeelslid.roepnaam != cache.roepnaam"
      :validation-object="$v.personeelslid.roepnaam"
      :is-disabled="disabledFieldsMap.roepnaam"
      :info="infoForInput('roepnaam')"
      :inputRemark="warningFieldsMap.roepnaam"
    >
    </text-input>
    <text-input
      v-if="!hiddenFieldsMap.initialen"
      v-model="personeelslid.initialen"
      id="pLidInitialen"
      :label="labels.initialen"
      :is-dirty="false"
      :validation-object="$v.personeelslid.initialen"
      :is-disabled="disabledFieldsMap.initialen"
      :info="infoForInput('initialen')"
    >
    </text-input>
    <gender-input
      v-model="$v.personeelslid.geslacht.$model"
      id="pLidGeslacht"
      :label="labels.geslacht"
      :is-disabled="disabledFieldsMap.geslacht"
      :info="infoForInput('geslacht')"
      :is-dirty="personeelslid.geslacht.trim() != cache.geslacht"
    >
    </gender-input>
    <date-input
      v-model="$v.personeelslid.geboortedatum.$model"
      :required="$v.personeelslid.geboortedatum.hasOwnProperty('required')"
      id="pLidGeboortedatum"
      :label="labels.geboortedatum"
      :is-dirty="personeelslid.geboortedatum != cache.geboortedatum"
      :is-disabled="disabledFieldsMap.geboortedatum"
      :info="infoForInput('geboortedatum')"
      :is-invalid="$v.personeelslid.geboortedatum.$invalid"
    >
    </date-input>
    <city-input
      v-if="personeelslid.geboorteland.land == 'België'"
      v-model="$v.personeelslid.geboorteplaats.$model"
      id="pLidGeboorteplaats"
      :label="labels.geboorteplaats"
      placeholder="Stad"
      :is-disabled="disabledFieldsMap.geboorteplaats"
      :info="infoForInput('geboorteplaats')"
      :is-dirty="personeelslid.geboorteplaats != cache.geboorteplaats"
      :required="$v.personeelslid.geboorteplaats.hasOwnProperty('required')"
    >
    </city-input>
    <text-input
      v-else
      v-model="$v.personeelslid.geboorteplaats.$model"
      id="pLidGeboorteplaats"
      :label="labels.geboorteplaats"
      :is-disabled="disabledFieldsMap.geboorteplaats"
      :info="infoForInput('geboorteplaats')"
      :is-dirty="personeelslid.geboorteplaats != cache.geboorteplaats"
      :validation-object="$v.personeelslid.geboorteplaats"
    >
    </text-input>
    <country-input
      v-model="$v.personeelslid.geboorteland.$model"
      id="pLidGeboorteland"
      :label="labels.geboorteland"
      :is-disabled="disabledFieldsMap.geboorteland"
      :info="infoForInput('geboorteland')"
      placeholder="Land"
      :is-dirty="personeelslid.geboorteland.land != cache.geboorteland.land"
    >
    </country-input>
    <yes-no-input
      v-model="personeelslid.persMindervalide"
      name="persMindervalideYesNo"
      id="pLidEditingMindervalide"
      :label="labels.persMindervalide"
      :is-disabled="disabledFieldsMap.persMindervalide"
      :is-dirty="personeelslid.persMindervalide != cache.persMindervalide"
    >
    </yes-no-input>
    <text-input
      v-model="$v.personeelslid.inszNr.$model"
      id="pLidInszNr"
      :label="labels.inszNr"
      :is-dirty="personeelslid.inszNr != cache.inszNr"
      :validation-object="$v.personeelslid.inszNr"
      :is-disabled="disabledFieldsMap.inszNr"
      :info="infoForInput('inszNr')"
    >
    </text-input>

    <text-input
      v-model="$v.personeelslid.stamnummer.$model"
      id="pLidStamnummer"
      :label="labels.stamnummer"
      :validation-object="$v.personeelslid.stamnummer"
      :is-dirty="false"
      :is-disabled="disabledFieldsMap.stamnummer"
      :info="infoForInput('stamnummer')"
    >
    </text-input>
    <text-input
      v-if="personeelslid.contrStamnummer"
      v-model="$v.personeelslid.contrStamnummer.$model"
      :validation-object="$v.personeelslid.contrStamnummer"
      id="pLidContrStamnummer"
      :label="labels.contrStamnummer"
      :is-dirty="false"
      :is-disabled="disabledFieldsMap.contrStamnummer"
      :info="infoForInput('contrStamnummer')"
    >
    </text-input>
    <text-input
      v-if="!hiddenFieldsMap.werknemerscode"
      v-model="$v.personeelslid.werknemerscode.$model"
      id="pLidwerknemerscode"
      :label="labels.werknemerscode"
      :validation-object="$v.personeelslid.werknemerscode"
      :is-dirty="false"
      :is-disabled="disabledFieldsMap.werknemerscode"
      :info="infoForInput('werknemerscode')"
    >
    </text-input>
    <nationality-input
      v-for="(v, index) in $v.personeelslid.natio.$each.$iter"
      :key="index"
      :is-disabled="disabledFieldsMap.natio"
      v-model="personeelslid.natio[parseInt(index)]"
      @delete-natio="deleteNationality(parseInt(index))"
      :id="'a-' + index"
      :label="
        personeelslid.natio.length != 1
          ? labels.natio.nationaliteit + ' ' + (parseInt(index) + 1)
          : labels.natio.nationaliteit
      "
      :is-dirty-natio="
        isDiffToCache(
          personeelslid.natio[parseInt(index)],
          cache.natio[parseInt(index)]
        )
      "
      :is-new="parseInt(index, 10) >= cache.natio.length"
      :show-delete="index != 0"
      :info="infoForInput('natio')"
    >
    </nationality-input>
    <div v-if="!disabledFieldsMap.natio" class="text-center mt-2">
      <plus-button
        :disabled="disabledFieldsMap.natio"
        @click="addNationality()"
        label="Nationaliteit toevoegen"
      ></plus-button>
    </div>
    <div class="pt-2 mt-3 border-top">
      <label class="font-weight-bold">Opmerking:</label>
      <textarea
        @input="onRemarkChange"
        v-model="currentRemark"
        rows="3"
        class="form-control mb-2"
        placeholder="Opmerking"
        type="text"
      ></textarea>
    </div>
    <file-upload
      label="Bewijsstuk(ken) uploaden:"
      :upload-percentage="0"
      @files-changed="onFilesChanged"
    ></file-upload>
  </div>
</template>

<script>
import diff from "deep-diff";
import { minLength, maxLength, required } from "vuelidate/lib/validators";
import { dateValidator } from "./../../utils/DateUtils.js";
import {
  proofValidator,
  proofSuppliedIfNeeded,
} from "../../utils/DossierUtils.js";
import DossierLabels from "./../DossierLabels.js";
import TextInput from "./../../inputs/TextInput.vue";
import DateInput from "./../../inputs/DateInput.vue";
import CityInput from "./../../inputs/CityInput.vue";
import YesNoInput from "./../../inputs/YesNoRadials.vue";
import CountryInput from "./../../inputs/CountryInput.vue";
import FileUpload from "./../../inputs/FileUpload.vue";
import GenderInput from "./../../inputs/GenderInput.vue";
import NationalityInput from "./../../inputs/NationalityInput.vue";
import PlusButton from "./../../interface/PlusButton.vue";

export default {
  name: "personeelslid-form",
  props: {
    personeelslid: {
      type: Object,
    },
    cache: {
      type: Object,
    },
    remark: {
      type: String,
    },
    attachments: {
      type: Array,
      required: false,
    },
    isInWizard: {
      type: Boolean,
      default: false,
    },
    disabledFieldsMap: {
      type: Object,
    },
    proofRequiredFieldsMap: {
      type: Object,
    },
    proofInfoFieldsMap: {
      type: Object,
    },
    hiddenFieldsMap: {
      type: Object,
    },
    warningFieldsMap: {
      type: Object,
      required: false,
    },
  },
  components: {
    TextInput,
    DateInput,
    CityInput,
    CountryInput,
    GenderInput,
    NationalityInput,
    PlusButton,
    FileUpload,
    YesNoInput,
  },
  data() {
    return {
      labels: DossierLabels.personeelslid,
      currentAttachments: this.attachments,
      currentRemark: this.remark,
    };
  },
  methods: {
    addNationality() {
      this.personeelslid.natio.push({
        id: 0,
        natType: 1,
        nationaliteit: "Belgische",
      });
    },
    deleteNationality(index) {
      this.personeelslid.natio.splice(index, 1);
    },
    isDiffToCache(newValue, cachedValue) {
      let parsedValue = JSON.parse(JSON.stringify(newValue));
      return diff(cachedValue, parsedValue) != undefined;
    },
    onFilesChanged(value) {
      this.currentAttachments = value;
      this.$emit("files-changed", this.currentAttachments);
    },
    onRemarkChange() {
      this.$emit("remark-changed", this.currentRemark);
    },
    infoForInput(valueName) {
      if (this.proofRequiredFieldsMap[valueName]) {
        if (this.proofInfoFieldsMap[valueName] != "") {
          return this.proofInfoFieldsMap[valueName];
        }
        return "Bewijsstuk vereist om dit veld aan te passen.";
      } else {
        return null;
      }
    },
    isFieldUpdated(fieldName) {
      let parsedValue = JSON.parse(
        JSON.stringify(this.personeelslid[fieldName])
      );
      return this.isDiffToCache(parsedValue, this.cache[fieldName]);
    },
  },
  computed: {
    doesFormRequireProof() {
      return Object.values(this.proofRequiredFieldsMap).indexOf(true) > -1;
    },
  },
  validations() {
    return {
      personeelslid: {
        naam: {
          required,
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.naam,
            this.isFieldUpdated("naam"),
            this.currentAttachments
          ),
          minLength: minLength(2),
          maxLength: maxLength(50),
        },
        voornaam: {
          required,
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.voornaam,
            this.isFieldUpdated("voornaam"),
            this.currentAttachments
          ),
          minLength: minLength(2),
          maxLength: maxLength(30),
        },
        voornaam2: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.voornaam2,
            this.isFieldUpdated("voornaam2"),
            this.currentAttachments
          ),
          maxLength: maxLength(30),
        },
        roepnaam: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.roepnaam,
            this.isFieldUpdated("roepnaam"),
            this.currentAttachments
          ),
          minLength: minLength(2),
          maxLength: maxLength(20),
        },
        initialen: {
          //minLength: minLength(2),
          //maxLength: maxLength(20),
        },
        werknemerscode: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.werknemerscode,
            this.isFieldUpdated("werknemerscode"),
            this.currentAttachments
          ),
          minLength: minLength(2),
          maxLength: maxLength(20),
        },
        stamnummer: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.stamnummer,
            this.isFieldUpdated("stamnummer"),
            this.currentAttachments
          ),
          maxLength: maxLength(20),
        },
        contrStamnummer: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.contrStamnummer,
            this.isFieldUpdated("contrStamnummer"),
            this.currentAttachments
          ),
          maxLength: maxLength(20),
        },
        geboortedatum: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.geboortedatum,
            this.isFieldUpdated("geboortedatum"),
            this.currentAttachments
          ),
          required,
          dateValidator,
        },
        geboorteplaats: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.geboorteplaats,
            this.isFieldUpdated("geboorteplaats"),
            this.currentAttachments
          ),
          required,
        },
        geboorteland: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.geboorteland,
            this.isFieldUpdated("geboorteland"),
            this.currentAttachments
          ),
          required,
        },
        persMindervalide: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.persMindervalide,
            this.isFieldUpdated("persMindervalide"),
            this.currentAttachments
          ),
          required,
        },
        geslacht: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.geslacht,
            this.isFieldUpdated("geslacht"),
            this.currentAttachments
          ),
          required,
        },
        inszNr: {
          proofValidator: proofSuppliedIfNeeded(
            this.proofRequiredFieldsMap.inszNr,
            this.isFieldUpdated("inszNr"),
            this.currentAttachments
          ),
          required,
        },
        natio: {
          $each: {
            proofValidator: proofSuppliedIfNeeded(
              this.proofRequiredFieldsMap.natio,
              this.isFieldUpdated("natio"),
              this.currentAttachments
            ),
            required,
          },
        },
      },
    };
  },
  watch: {
    $v: {
      handler(value) {
        this.$emit("validation-change", value.$invalid);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
